import { RecProps } from './types'
import { App } from './App'

export const Fragment = (props: RecProps) => {
  return (
    <App {... props} />
  )
}
